import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-technologies',
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './technologies.component.html',
  styleUrl: './technologies.component.scss',
})
export class TechnologiesComponent {
  private route = inject(Router);

  goToLink(url: string, external?: boolean): void {
    if (external) {
      if (typeof window !== 'undefined') {
        window.open(url, '_blank');
        return;
      }
    }
    this.route.navigateByUrl(url);
  }
}
